import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.help_recipient_list'

function RecipientListI18n({ classes }: { classes: ReturnType<typeof styles> }) {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <div className={classes.content} data-testid="content">
      <p>{formatMessage('intro')}</p>
      <br />
      <br />
      {formatMessage('instructions')}
    </div>
  )
}

function RecipientList(_props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <RecipientListI18n classes={classes} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      <p>
        The <b>Recipients List</b> displays the unique recipients seen in the last 30 days for the selected domain. Use
        the Search box to search for a specific recipient or set of recipients.
      </p>
      <br />
      <br />
      Select the total number of results to display per page from the
      <b>Results per page</b> drop-down menu, and click the controls to the right of the menu to move through the
      results. To return to the <b>Domains</b> page, click <b>Back to Domains</b>.
    </div>
  )
}

export default RecipientList
